import React from "react";
import "./Hero.scss";
import BackVideo from "../../../assets/video/rrropt.mp4";

import GAF from "../../../assets/logos/gaf.png";
import RCA from "../../../assets/logos/rca.png";
import HAR from "../../../assets/logos/har.png";
import HOM from "../../../assets/logos/hom.png";
import GoogleRating from "../../googleReviews/GoogleRating";
import { isReactSnap } from "../../../utils/reactSnap";

export default function Hero() {
  return (
    <div className="heroBase">
      <div className="topHeroDivVideo">
        <div className="greyDiv"></div>
        {!isReactSnap() && (
          <video className="videoTag" autoPlay="autoplay" loop muted playsInline>
            <source src={BackVideo} type="video/mp4" />
          </video>
        )}
        <div className="topHeroDivData">
          <div className="dataContentHero">
            <p className="heroTitleTxt">Your</p>
            <p className="heroTitleTxt">local roofing</p>
            <p className="heroTitleTxt">professionals</p>
            <h1 className="heroTitleSubTxt">
              Roofing & Remodeling services throughout the greater Houston area
            </h1>
            <GoogleRating variant="hero" />
          </div>
        </div>
      </div>

      <div className="bottomLogoHeroDiv">
        <div className="bottomDataDiv">
          <div className="respOnlyDiv">
            <div className="logosFlexBase">
              <div className="logoGrid">
                <img
                  src={GAF}
                  alt="GAF Certified Plus roofing contractor badge"
                  className="heroLogo"
                />
              </div>
              <div className="logoGrid">
                <img
                  src={HOM}
                  alt="Approved company for Roofing"
                  className="heroLogo"
                />
              </div>
              <div className="logoGrid">
                <img
                  src={RCA}
                  alt="Certified company lists for Roofing"
                  className="heroLogo"
                />
              </div>
              <div className="logoGrid">
                <img
                  src={HAR}
                  alt="HARCA Certification for roofing and restoration"
                  className="heroLogo"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
